/* eslint-disable no-underscore-dangle */
export class ResponseError extends Error {
  constructor(status, body) {
    // Extending error requires this workaround, see https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    super(`Response Error: ${status}`);
    Object.setPrototypeOf(this, ResponseError.prototype);
    this._status = status;
    this._body = body;
  }
  get status() {
    return this._status;
  }
  get body() {
    return this._body;
  }
}